import React, { useEffect, useState } from 'react';
import api from '../utils/api';
import './LocationPanel.css';

export default function LocationPanel({ location, userLat, userLon, onClose, onInteractionComplete }) {
    const [tab, setTab] = useState('character');
    const [artifacts, setArtifacts] = useState([]);
    const [quests, setQuests] = useState([]);
    const [feedback, setFeedback] = useState(null);
    const [answer, setAnswer] = useState('');
    const [busy, setBusy] = useState(false);

    useEffect(() => {
        api.get(`/locations/${location.id}/artifacts`).then((r) => setArtifacts(r.data))
        api.get(`/locations/${location.id}/quests`).then((r) => setQuests(r.data))
        api.post(`/game/visit/${location.id}`, { lat: userLat, lon: userLon }).catch(() => {})
    }, [location.id, userLat, userLon]);

    const switchTab = (t) => {
        setTab(t);
        setFeedback(null);
      }

    const collectArtifact = async (id) => {
        setBusy(true);
        setFeedback(null);

        try {
            const res = await api.post(`/game/collect/${id}`, { lat: userLat, lon: userLon });

            setFeedback({ ok: true, msg: `🏺 ${res.data.artifact.name} добавлен! +${res.data.xp_awarded} XP`, ach: res.data.new_achievements });
            onInteractionComplete();
        } catch (err) {
            setFeedback({ ok: false, msg: err.response?.data?.error || 'Ошибка' });
        } finally {
            setBusy(false);
        }
    }

    const submitAnswer = async (questId) => {
        if (!answer.trim()) return;

        setBusy(true);
        setFeedback(null);

        try {
            const res = await api.post(`/game/quest/${questId}/answer`, { lat: userLat, lon: userLon, answer });

            if (res.data.correct) {
                setFeedback({ ok: true, msg: `✅ ${res.data.message} +${res.data.xp_awarded} XP`, ach: res.data.new_achievements });
                setAnswer('');
                onInteractionComplete();
            }

            else setFeedback({ ok: false, msg: res.data.message, hint: res.data.hint });
        } catch (err) {
            setFeedback({ ok: false, msg: err.response?.data?.error || 'Ошибка' });
        } finally {
            setBusy(false);
        }
    }

    return (
        <div className='panel'>
      <div className='panel-header'>
        {location.photo_url && <img src={location.photo_url} alt={location.name} className='panel-photo' />}
        <div className='panel-title-block'>
          <h2>{location.name}</h2>
          <span className='panel-era'>{location.era} · {location.object_type}</span>
        </div>
        <button className='panel-close' onClick={onClose}>✕</button>
      </div>

      <p className='panel-desc'>{location.description}</p>

      {feedback?.ach?.length > 0 && (
        <div className='ach-toast'>🏆 {feedback.ach.map((a) => a.title).join(', ')}!</div>
      )}

      <div className='panel-tabs'>
        {[['character', '📖 Персонаж'], ['artifact', '🏺 Артефакт'], ['quest', '📜 Квест']].map(([key, label]) => (
          <button key={key} className={`tab-btn ${tab === key ? 'active' : ''}`} onClick={() => switchTab(key)}>
            {label}
          </button>
        ))}
      </div>

      <div className='panel-body'>
        {tab === 'character' && (
          <div>
            <h3>🎭 {location.character_name || 'Исторический свидетель'}</h3>
            <blockquote className='character-story'>
              {location.character_story || 'Этот объект хранит молчание веков…'}
            </blockquote>
          </div>
        )}

        {tab === 'artifact' && (
          <div>
            {artifacts.length === 0
              ? <p className='empty'>На этой локации нет артефактов</p>
              : artifacts.map((art) => (
                  <div key={art.id} className='artifact-card'>
                    <div className='artifact-info'>
                      <h4>{art.name}</h4>
                      <span className='artifact-meta'>{art.artifact_type} · {art.era}</span>
                      <p>{art.description}</p>
                      <span className='xp-badge'>+{art.xp_reward} XP</span>
                    </div>
                    <button className='collect-btn' onClick={() => collectArtifact(art.id)} disabled={busy}>
                      {busy ? '…' : 'Взять'}
                    </button>
                  </div>
                ))
            }
            {feedback && <div className={`fb ${feedback.ok ? 'ok' : 'err'}`}>{feedback.msg}</div>}
          </div>
        )}

        {tab === 'quest' && (
          <div>
            {quests.length === 0
              ? <p className='empty'>На этой локации нет квестов</p>
              : quests.map((q) => (
                  <div key={q.id} className='quest-card'>
                    <h4>📜 {q.title}</h4>
                    {q.description && <p className='quest-desc'>{q.description}</p>}
                    <p className='quest-q'><strong>{q.question}</strong></p>
                    <div className='quest-row'>
                      <input
                        className='quest-input'
                        type='text'
                        placeholder='Ваш ответ…'
                        value={answer}
                        onChange={(e) => setAnswer(e.target.value)}
                        onKeyDown={(e) => e.key === 'Enter' && submitAnswer(q.id)}
                      />
                      <button className='quest-btn' onClick={() => submitAnswer(q.id)} disabled={busy}>
                        {busy ? '…' : 'OK'}
                      </button>
                    </div>
                    {feedback && (
                      <div className={`fb ${feedback.ok ? 'ok' : 'err'}`}>
                        {feedback.msg}
                        {feedback.hint && <p className='hint'>💡 {feedback.hint}</p>}
                      </div>
                    )}
                    <span className='xp-badge'>Награда: +{q.xp_reward} XP</span>
                  </div>
                ))
            }
          </div>
        )}
      </div>
    </div>
    );
}
